import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './signin.css';
import heroImage from './images/bg-event-01.jpg';

const Signin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (username === 'admin' && password === 'admin123') {
      navigate('/dashboard');
    } else {
      setError('Invalid username or password');
    }
  };

  return (
    <div className='sign-in'><br /><br /><br />
      <section className='hero' style={{backgroundImage: `url(${heroImage})`}}>
        <div className='form-right'>
          <h1>
            Admin Login
          </h1><br />
          <p className='p1'>Access the dashboard with your credentials.</p><br />
        </div> 
          <div className='form-left'>
            <form onSubmit={handleSubmit}>  
              <p className='luj'>Username<br /></p>
              <input 
                type='text' 
                className='inputt' 
                value={username} 
                onChange={(e) => setUsername(e.target.value)} 
              />
              <p className='luj'>Password<br /></p>
              <input 
                type='password' 
                className='inputt' 
                style={{marginBottom: "10px"}} 
                value={password} 
                onChange={(e) => setPassword(e.target.value)} 
              />
              {error && <p style={{color: 'red'}}>{error}</p>}
              <button className='sign-btn' type='submit'>Login</button>
            </form>
          </div>
      </section>
    </div>
  )
}

export default Signin